import { useEffect, useRef, useState } from "react";
import lowerThird from "../../../../assets/images/ai-videos/motorsport/lowerthird.png";

export default function MotorsportSlidePreview({ news }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    function updateScale() {
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      setScale(width / 1920);
    }
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full relative select-none"
      style={{
        aspectRatio: "16 / 9",
        overflow: "hidden",
        backgroundColor: "rgba(0, 0, 0, 0)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {/* Background Image */}
        <img
          src={news.image}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        <img
          src={lowerThird}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Category - positioned above title */}
        <div
          style={{
            background:
              "linear-gradient(180deg, #ffffff 0%, #f5f5f5 15%, #e0e0e0 30%, #d0d0d0 45%, #b8b8b8 60%, #a8a8a8 75%, #909090 90%, #787878 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))",
            fontSize: "3em",
            fontFamily: "MuseoSansTR-700",
            fontWeight: "900",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "clip",
            position: "absolute",
            bottom: 200,
            left: 415,
            width: 1150,
          }}
        >
          {news.category}
        </div>

        {/* Title bar at bottom */}
        <div
          style={{
            background:
              "linear-gradient(180deg, #ffffff 0%, #f5f5f5 15%, #e0e0e0 30%, #d0d0d0 45%, #b8b8b8 60%, #a8a8a8 75%, #909090 90%, #787878 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))",
            fontSize: "3em",
            fontFamily: "MuseoSansTR-700",
            fontWeight: "900",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "clip",
            position: "absolute",
            bottom: 115,
            left: 415,
            width: 1350,
          }}
        >
          {news.title}
        </div>
      </div>
    </div>
  );
}
